<template>
  <el-dialog
    :title="$t('componentConditionManage.editCondition')"
    :visible.sync="dialogVisible"
    width="60%"
    @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item :label="$t('componentConditionManage.name')" prop="name">
        <el-input
          v-model="formData.name"
          :placeholder="$t('componentConditionManage.namePlaceholder')"
          clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('componentConditionManage.holdpace')" prop="holdpace">
        <el-input
          v-model="formData.holdpace"
          :placeholder="$t('componentConditionManage.holdpacePlaceholder')"
          clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('componentConditionManage.param')" prop="param">
        <el-input
          v-model="formData.param"
          :placeholder="$t('componentConditionManage.paramPlaceholder')"
          clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('componentConditionManage.type')" prop="type">
        <el-select
          v-model="formData.type"
          :placeholder="$t('componentConditionManage.typePlaceholder')"
          style="width:100%">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('componentConditionManage.seq')" prop="seq">
        <el-input
          v-model="formData.seq"
          :placeholder="$t('componentConditionManage.seqPlaceholder')"
          clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('componentConditionManage.remark')">
        <el-input
          type="textarea"
          v-model="formData.remark"
          :placeholder="$t('componentConditionManage.remarkPlaceholder')"
          :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="handleSubmit">{{$t('common.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateReportCustomComponentCondition } from '@/api/dev/componentConditionApi'

export default {
  name: 'EditComponentCondition',
  data() {
    return {
      dialogVisible: false,
      formData: {
        conditionId: '',
        componentId: '',
        name: '',
        holdpace: '',
        param: '',
        type: '',
        remark: '',
        seq: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('componentConditionManage.nameRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('componentConditionManage.nameMaxLength'), trigger: 'blur' }
        ],
        holdpace: [
          { required: true, message: this.$t('componentConditionManage.holdpaceRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('componentConditionManage.holdpaceMaxLength'), trigger: 'blur' }
        ],
        param: [
          { required: true, message: this.$t('componentConditionManage.paramRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('componentConditionManage.paramMaxLength'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('componentConditionManage.typeRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('componentConditionManage.seqRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('componentConditionManage.seqNumber'), trigger: 'blur' }
        ],
        conditionId: [
          { required: true, message: this.$t('componentConditionManage.conditionIdRequired'), trigger: 'blur' }
        ]
      },
      typeOptions: [
        { value: 'text', label: this.$t('componentConditionManage.text') },
        { value: 'date', label: this.$t('componentConditionManage.date') }
      ]
    }
  },
  methods: {
    open(params) {
      this.resetForm()
      Object.assign(this.formData, params)
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = {
        conditionId: '',
        componentId: '',
        name: '',
        holdpace: '',
        param: '',
        type: '',
        remark: '',
        seq: ''
      }
    },
    handleClose() {
      this.resetForm()
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updateReportCustomComponentCondition(this.formData)
            this.$message.success(this.$t('common.submitSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('修改失败:', error)
          }
        }
      })
    }
  }
}
</script>